// appnavtargets
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchWithAuth } from "../utils/fetchWithAuth";

export function useMessageCenterTarget() {
  const { pathname } = useLocation();
  const [me, setMe] = useState(null);

  useEffect(() => {
    // best-effort; navbar should not hard-fail if this 401s
    fetchWithAuth("/api/accounts/me/").then(setMe).catch(() => {});
  }, []);

  return useMemo(() => {
    if (pathname.startsWith("/company")) return "/company/messages";
    if (pathname.startsWith("/dashboard/contractor")) return "/dashboard/contractor/messages";
    // fallback by role/org
    return me?.organization ? "/company/messages" : "/dashboard/contractor/messages";
  }, [pathname, me]);
}

export function useEditProfileTarget() {
  const { pathname } = useLocation();
  const [me, setMe] = useState(null);

  useEffect(() => {
    fetchWithAuth("/api/accounts/me/").then(setMe).catch(() => {});
  }, []);

  return useMemo(() => {
    if (pathname.startsWith("/company")) return "/company/onboarding"; // or "/company/org-management"
    if (pathname.startsWith("/dashboard/contractor")) return "/dashboard/contractor/profile";
    // fallback by role/org
    return me?.organization ? "/company/onboarding" : "/dashboard/contractor/profile";
  }, [pathname, me]);
}
export const navTargets = {
    messagesCenter(me, { threadId } = {}) {
      // If user has an org, prefer company messages; otherwise contractor messages
      const base = me?.organization ? "/company/messages" : "/dashboard/contractor/messages";
      return threadId ? `${base}?thread=${threadId}` : base;
    },
    contractDetail(me, { contractId } = {}) {
      const base = me?.organization ? "/company/contracts" : "/dashboard/contractor/contract-center";
      return contractId ? `${base}/${contractId}` : base;
    },
  };
